<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="w-full rounded-10 bg-a-egg-f5ebdc p-3 text-a-brown-502314">
                    <div class="font-bold text-center py-4 lg:text-18">{{lbl.shoppingcart.popup_upsale.your_may_also_like}}</div>
                    <div class="absolute top-4 right-4 flex">
                        <img class="ml-auto mr-0" @click="clickCancel()" src="@/assets/icon/ic-close-brown.svg" />
                    </div>
                    <div v-if="campaignList.length != 0">
                        <UpsaleSlider
                            :campaigns="campaignList"
                            @itemUpdate="calSummery()"
                        ></UpsaleSlider>
                    </div>
                    <div class="font-bold text-18 text-center pb-4">{{getTotal()}}</div>
                    <div class="flex">
                        <div class="w-52 m-auto pb-3" >
                            <RedButton  @click="clickOk()">
                                {{btnOk}}
                            </RedButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import RedButton from "@/components/Button/RedButton.vue";
import UpsaleSlider from "./component/UpsaleSlider.vue";

export default {
    name: "UpsaleModal",
    mixins: [LocaleMixin],
    components: {
        RedButton,
        UpsaleSlider
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            campaignList: [],
            total: 0,
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.campaignList = config.campaignList;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk(this.campaignList);
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        calSummery: function() {
            this.total = 0;
            for (let campaign of this.campaignList) {
                if (campaign.quantity && campaign.quantity != 0) {
                    this.total += campaign.pricePerUnit * campaign.quantity;
                }
            } 
        },
        getTotal: function() {
            return Util.stringFormat(this.lbl.shoppingcart.popup_upsale.total,this.FilterNumberFormat(this.total))
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
